import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'promise-polyfill/src/polyfill'
import 'whatwg-fetch'

import datavue from '@datavue/datavue'
import { datavueUI } from '@datavue/datavue-ui'
import pages from './pages/manifest'

import * as am4core from '@amcharts/amcharts4/core'
import daqsTheme from '@/components/charts/charts/daqsTheme'

// css and bootstrap js for pills
import 'bootstrap'
import './styles/main.scss'

// load datavue
Vue.use(datavue, { store, router, pages })
Vue.use(datavueUI)
Vue.config.productionTip = false

// initiate app
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// configure amcharts
am4core.options.commercialLicense = true
am4core.useTheme(daqsTheme)
// am4core.options.queue = true
// am4core.options.onlyShowOnViewport = true

router.beforeEach((to, from, next) => {
  if (to.name) {
    document.title = 'NRBS Results Viewer | ' + to.name.charAt(0).toUpperCase() + to.name.slice(1)
  } else {
    document.title = 'NRBS Results Viewer | Home'
  }
  next()
})
